import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { BrowserTracing } from '@sentry/tracing';
import 'index.css';
import App from './App';
import { theme } from 'components/theme/theme';
// import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LicenseManager } from 'ag-grid-enterprise';
import SnackBar from 'components/Snackbar';
import config from './config';
import store from './store';
import { QueryClient, QueryClientProvider } from 'react-query';
const queryClient = new QueryClient();

// Global declaration of chameleon object
declare global {
  interface Window {
    analytics: any;
    Calendly: any;
    MediaRecorder: any;
    submissionFileUploadId: any;
    forceCancelUpload: any;
  }
}

if (
  config.REACT_APP_ENVIRONMENT === 'production' ||
  config.REACT_APP_ENVIRONMENT === 'beta'
) {
  Sentry.init({
    dsn: 'https://eec4dcbc759b4c24a7e2d00cc4149b00@o4504486243336192.ingest.sentry.io/4504892591046656',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: config.REACT_APP_ENVIRONMENT,
    release: config.SENTRY_RELEASE,
  });
}

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-080638}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Xenia_Platform_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Xenia_Platform_Inc.}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Xenia_Platform_Inc.}_need_to_be_licensed___{Xenia_Platform_Inc.}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_August_2026}____[v3]_[01]_MTc4NTYyNTIwMDAwMA==9c45611be8cdd8e07a9de0f63550b568',
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackBar>
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </SnackBar>
    </ThemeProvider>
  </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
